<template>
  <div class="border-left pl-2">
    <CRow v-if="!hide_fields || !hide_fields.first_name">
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.first_name ? label_overrides.first_name : 'First Name'"
          placeholder=""
          v-model="form.first_name"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow v-if="!hide_fields || !hide_fields.last_name">
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.last_name ? label_overrides.last_name : 'Last Name'"
          placeholder=""
          v-model="form.last_name"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow v-if="!hide_fields || !hide_fields.type">
      <CCol sm="12">
        <CSelect
            :label="label_overrides && label_overrides.type ? label_overrides.type : 'Type'"
            placeholder=""
            :value.sync="form.type"
            :options="contact_types"
            :horizontal="true"
            :addLabelClasses="['font-weight-bold']"
            required
        />
      </CCol>
    </CRow>
    <CRow v-if="!hide_fields || !hide_fields.phone">
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.phone ? label_overrides.phone : 'Phone'"
          placeholder=""
          v-model="form.phone"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow v-if="!hide_fields || !hide_fields.mobile">
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.mobile ? label_overrides.mobile : 'Cell'"
          placeholder=""
          v-model="form.mobile"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
        />
      </CCol>
    </CRow>
    <CRow v-if="!hide_fields || !hide_fields.email">
      <CCol sm="12">
        <CInput
          :label="label_overrides && label_overrides.email ? label_overrides.email : 'Email'"
          placeholder=""
          v-model="form.email"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow v-if="commit">
      <CCol sm="7"></CCol>
      <CCol sm="5">
        <CButtonGroup class="w-100">
          <CButton @click="$emit('cancel')" color="default" class="btn-square">Cancel</CButton>
          <CButton class="btn-sf btn-square" @click="save">Save</CButton>
        </CButtonGroup>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Contact from "../../../models/Contact"
import CustomerContact from "../../../models/CustomerContact";

export default {
  name: 'ContactEditForm',
  data() {
    return {
      form: {
        first_name: null,
        last_name: null,
        type: null,
        phone: null,
        mobile: null,
        // fax: null,
        email: null,
        restrictAccess: true
      },
      contact_types: [
        {value: '', label: 'No Type Assigned'},
        {value: 'Sales', label: 'Sales'},
        {value: 'Accounting', label: 'Accounting'},
        {value: 'Territory Manager', label: 'Territory Manager'},
        {value: 'Owner', label: 'Owner'},
      ],
    };
  },
  props: {
    contact: {
      type: Object,
      default: null
    },
    commit: {
      type: Boolean,
      default: true
    },
    label_overrides: {
      type: Object,
      default: null
    },
    hide_fields: {
      type: Object,
      default: null
    },
  },
  methods: {
    getPayload() {
      let payload = JSON.parse(JSON.stringify(this.form));
      payload.full_name = [payload.first_name, payload.last_name].join(' ');
      return payload;
    },
    save() {
      if(!this.commit) {
        return;
      }
      this.updateContact().then((contact) => {
        this.$emit('onSave', contact);
        let customer_contact = CustomerContact.query().where('contact_id', contact.id).first();
        if(customer_contact) {
          CustomerContact.api().export(customer_contact.id);
        }
      });
    },
    updateContact: function() {
      return Contact.api().update(this.contact.id, this.getPayload()).then((response) => {
        return response.entities.contacts[0];
      });
    },
  },
  watch: {
    form: {
      handler: function() {
        this.$emit('change', this.getPayload());
      },
      deep: true
    },
    contact: {
      handler: function() {
        for(let k in this.form) {
          if(this.contact) {
            this.form[k] = this.contact[k];
          }
        }
      },
      deep: true
    },
  },
  mounted() {
    for(let k in this.form) {
      if(this.contact) {
        this.form[k] = this.contact[k];
      }
    }
  }
}
</script>
